import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, QueryList, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, DataService } from '../../../_services/index';
import { Response } from '@angular/http';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import * as _ from 'lodash';
import { environment } from '../../../../environments/environment';
import { TreeviewItem, TreeviewConfig, TreeviewComponent } from "ngx-treeview";
import { ToastrService } from "../../../_services/toastr.service";
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import * as uuid from 'uuid';
import { Subscription } from 'rxjs/Rx';

declare const alertify: any;

@Component({
	selector: 'app-download',
	templateUrl: './download.component.html',
	styleUrls: ['./download.component.css'],
	providers: [ToastrService, NgbModal]
})
export class DownloadComponent implements OnInit, AfterViewInit, AfterViewChecked {
	bundleID: string;
	bundleName: string;
	link: string;
	hover: string;
	button: string;
	zipName: string;
	private sub: any;
	private responseItems: any;
	isDownload: boolean;
	enableButton: boolean;
	instantDownloadLink: string = '';
	linkerClickedFor: string = '';
	isDownloadCancelled: boolean = false;
	validLink: boolean;
	link_active: boolean;
	prodImageKey: string = 'assets/img/dummy.png';
	isNoData: boolean;
	headerExpanded: boolean = true;
	onlineLibButtonHover:boolean = false;
	private checkedProductItems: Array<any> = [];
	private checkedFolderItems: Array<any> = [];
	private checkedItems: Array<any> = [];
	private checkedFileItems: Array<any> = [];
	private selectedIsbn: string;
	private internalTcmId: string;
	progressBarRef: NgbModalRef;
	thanksRef: NgbModalRef;
	progressControl: any;
	disableCancelBtn: boolean = false;
	modalConf: NgbModalOptions;
	thanksModalConf: NgbModalOptions;
	noSelectedBtnStyle: string;
	downloadRequestSubscription: Subscription;
	public treeSettings: any = {
		isCollapsedOnInit: false,
		sort: 'asc',
		static: false,
		leftMenu: false,
		rightMenu: false,
		cssClasses: {
			collapsed: 'fa fa-plus',
			expanded: 'fa fa-minus',
			empty: 'fa fa-plus disabled',
			leaf: ''
		},
		templates: {
			node: '',
			leaf: ''
			// node: '<i class="fa fa-folder-o"></i>',
			// leaf: '<i class="fa fa-file-o"></i>'
		}
	};

	private serverBase: string;

	websiteTitle: string;

	// ------ Ngx Treeview-----
	items: TreeviewItem[];
	
	configX = TreeviewConfig.create({
		hasAllCheckBox: false,
		hasFilter: false,
		hasCollapseExpand: false,
		decoupleChildFromParent: false,
		maxHeight: 500
	});
	values: number[];
	treedata: Array<any>;
	childTreeData: Array<any> = [];
	currentDropdownSelection: any = null;
	@ViewChild('.form-check-label') label: ElementRef;
	@ViewChild('linker', { read: ElementRef }) linker: ElementRef;
	isAllSelected: boolean;
	fileCounter: number;
	totalFileSizeCounter: number;
	selectedContents: Array<string>;
	titleMyContent: string;
	progressBarValue: number;
	gridViewEnabled: boolean = true;
	downloadNewVersion: boolean = true;
	contentScrollTop:number = 0;

	constructor(private _dataService: DataService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _authenticationService: AuthenticationService,
		private _route: ActivatedRoute,
		public _toastrService: ToastrService,
		private _modalService: NgbModal,
		private _spinner: NgxSpinnerService,
		// private prohttp: ProgressHttp,
	) {
		this.validLink = false;
		this.enableButton = false;
		this.thanksModalConf = {};
		this.thanksModalConf.size = 'sm';
		this.thanksModalConf.windowClass = 'thanks-modal';
		this.modalConf = {};
		this.modalConf.backdrop = 'static';
		this.modalConf.keyboard = false;
		this.sub = this._route.params.subscribe(params => {
			this.bundleID = params['bundleID'];
			this.bundleName = params['bundleName'];
			this.link = params['link'];
			this.prodImageKey = params['imageKey'];
			
			/*Page's GA data */
			(<any>window).gtag('config', environment.gaId, { 'page_path': `/${this.bundleID}-${this.bundleName}` });

			this.link_active = params['active'] === '1' ? true : false;

			if (this.link === null) {
				this.validLink = false;
				this.link_active = false;
			} else if (this.link.trim() === "") {
				this.validLink = false;
				this.link_active = false;
			} else if (this.link === "invalid") {
				this.validLink = false;
				this.link_active = false;
			} else if (this.link.trim().length > 4 && this.link.trim() !== "" && this.link.trim() !== "invalid" && this.link !== null) {
				this.validLink = true;
				if (this.link.indexOf('http') < 0) {
					this.link = 'http://' + this.link;
				}
			} else {
				this.validLink = false;
			}
			this.button = params['button'];
			this.hover = params['hover'];
			if (this.link !== 'invalid' && this.button !== 'invalid' && this.hover !== 'invalid') {
				this.getPublicImageUrl(this.button, 'button');
				this.getPublicImageUrl(this.hover, 'hover');
				this.getPublicImageUrl(this.prodImageKey, 'imageKey');
				this.enableButton = true;
			} else {
				this.enableButton = false;
			}

		});
	}

	ngOnInit() {
		this.isDownload = false;
		this.serverBase = environment.serverBase;
		this.fileCounter = 0;
		this.totalFileSizeCounter = 0;
		this.isAllSelected = false;
		this.isNoData = false;
		this.progressBarValue = -1;
		this.getContentScrolltop((top)=>{
            this.contentScrollTop = top;
        })
	}
	sortingOption:any = null;
	ngAfterViewInit(): void {
		this.sub = this._route.params.subscribe(params => {
			this.bundleID = params['bundleID'];
			this.bundleName = params['bundleName'];
			console.log(this.bundleID == '1573832976778')
			this.getBundleContent('/auth/getProductTreeList', {
				itemID: this.bundleID,
				itemType: null,
				settings: {},
				itemList: null
			}, (err, response, zipName, meta) => {
				if (err) {
					this._toastrService.typeCustomError(err);
				} else {
					this.responseItems = JSON.parse(JSON.stringify(response));
					this.zipName = JSON.parse(JSON.stringify(zipName));
					this.isDownload = true;
					// Getting total files count.
					if (Array.isArray(response)) {
						response.map((p, k) => {
							// product
							if(p.level == 1) {
								p.tcm_type = 'root_folder';
								this.sortingOption = p.sort_by ? p.sort_by : null;
							}
							const loop = (childArr) => {
								if (!childArr)
									return;
								if (Array.isArray(childArr)) {
									childArr.map((pc, kc) => {
										if (pc.tcm_type === 'file') {
											pc.data.canShare = pc.data.canShare ? pc.data.canShare : false;
											this.fileCounter++;
											this.totalFileSizeCounter += pc.data.Size;

										} else {
											loop(pc.children);
										}
									});
								}
							}
							loop(p.children);
						});
					}

					this.treedata = [];
					this.childTreeData = [];
					for (const tv of response) {
						if (Array.isArray(tv.children)) {
							if ((tv.tcm_type === 'root_folder') || (!tv.tcm_type) || (tv.tcm_type === undefined)) {
								this.isNoData = false;
								tv.isNoData = false;
							}
							if (tv.children.length > 0) {
								tv.children.map((prodChild, i) => {
									this.treeLooper(prodChild, tv.children);
								});
							} else {
								if (((tv.tcm_type === 'root_folder') || (!tv.tcm_type) || (tv.tcm_type === undefined)) && tv.children.length < 1) {
									this.isNoData = true;
									tv.isNoData = true;
								}
							}
						} else {
							if (((tv.tcm_type === 'root_folder') || (!tv.tcm_type) || (tv.tcm_type === undefined)) && (tv.children || []).length < 1) {
								this.isNoData = true;
								tv.isNoData = true;
							}
						}

						tv.value = JSON.parse(JSON.stringify(tv));
						this.treedata.push(tv);
					}
					if(this.treedata && this.treedata[0]) {
						this.childTreeData = this.treedata;
					} else {
						this.childTreeData = [];
					}
					(function expandAll(el:any){
						let expandable = false;
						el.forEach((_el:any)=>{
							if(_el && _el.tcm_type != "file") expandable = true;
							if(_el && _el.tcm_type != "file" && _el.collapsed) _el.collapsed = false;
							if(_el && _el.tcm_type != "file" && _el.children && _el.children.length > 0) _el.expandable = expandAll(_el.children);
						});
						return expandable;
					})(this.childTreeData);
					this.currentDropdownSelection = this.treedata[0];
					this.websiteTitle = meta.websiteTitle || '';
				}
				// this.link = meta.link;
			});
		});
	}
	goToHome() {
		sessionStorage.setItem('loadHomeFromSession', 'true');
		this._router.navigate(['/home']);
	}
	onTreeItemClicked(e:any){
		console.log("event emmitted ", e.item);
		this.currentDropdownSelection = e.item;
	}
	ngAfterViewChecked() {
		if (this.linker && this.linkerClickedFor !== this.instantDownloadLink && this.instantDownloadLink !== '') {
			this.linker.nativeElement.click();
			this.linkerClickedFor = this.instantDownloadLink;
			setTimeout(() => {
				this.instantDownloadLink = '';
			}, 100);
		}
	}

	/*Tree items sorting*/

	treeLooper(childErray, parentOfErray) {
		if(this.sortingOption !== 'none' )parentOfErray = this.sortArrayOfObjects(parentOfErray, 'text', 'asc');
		if (Array.isArray(childErray.children)) {
			childErray.children.map((errayItem, x) => {
				this.treeLooper(errayItem, childErray.children);
			});
		}

	}

	sortArrayOfObjects(a: Array<{ 'text': string, 'tcm_type': string }>, key: string, order: string): Array<any> {
		return a.sort((x, y) => {
			if (order === 'asc')
				return (x[key].toLowerCase() < y[key].toLowerCase()) ? -1 : ((x[key].toLowerCase() > y[key].toLowerCase()) ? 1 : 0);
			if (order === 'desc')
				return (x[key].toLowerCase() < y[key].toLowerCase()) ? 1 : ((x[key].toLowerCase() > y[key].toLowerCase()) ? -1 : 0);
		});
	}

	/*Tree items sorting*/

	getPublicImageUrl(img_key, type): void {
		if (img_key) {
			const body = {
				'img_key': img_key
			};
			this._dataService.post('/auth/getPublicUrl', body)
				.subscribe((res: { response: string, response_message: any }) => {
					if (res.response !== 'success') {
						return img_key;
					}
					if (type === 'button') {
						this.button = res.response_message || '';
					} else if (type === 'hover') {
						this.hover = res.response_message || '';
					}
				});
		} else {
			// this.current_image = this.button_image = this.hover_image = 'assets/images/dummy.png';
		}
	}

	getPublicUrl(key:string, options:{hideLoader?:boolean, shareable?:boolean}={hideLoader:false, shareable:false}): Promise<any> {
		return new Promise((resolve, reject)=>{
			if (key) {
				const body = {
					'img_key': key,
					'shareable': options.shareable
				};
				this._dataService.post('/auth/getPublicUrl', body, {showBusy: !options.hideLoader})
					.subscribe((res: { response: string, response_message: any }) => {
						if (res.response !== 'success') {
							reject("ERROR: could not create preview url.");
						} else {
							resolve(res.response_message);
						}
					});
			} else {
				reject("ERROR: No item selected");
			}
		});
	}

	getFileObject(options:{key: string, type: string, hideLoader?: boolean, responseType?: string, observable? : boolean, productId? : any}): any {
		if(!options.observable) {
			return new Promise((resolve, reject)=>{
				if (options.key) {
					const body = { 'key': options.key, type: options.type, responseType: (options.responseType || 'blob') };
					this._dataService.post('/auth/getFile', body, {showBusy: !options.hideLoader} ).subscribe((res: any) => {
						if(res.type !== options.type) {
							reject("ERROR: could not download file for preview.");
						} else {
							resolve(res);
						}
					});
				} else {
					reject("ERROR: No item selected");
				}
			});
		} else {
			return new Observable((observer) => {
				if (options.key) {
					const body = { 'key': options.key, type: options.type, responseType: (options.responseType || 'blob'), productId: options.productId };
					this._dataService.post('/auth/getFile', body, {showBusy: !options.hideLoader} ).subscribe((res: any) => {
						if(res.type !== options.type) {
							observer.error("ERROR: could not download file for preview.");
						} else {
							observer.next(res);
						}
					});
				} else {
					observer.error("ERROR: No item selected");
				}
			});
			
		}
	}

	generatePreview(options:{key: string, type: string, hideLoader?: boolean, responseType?:any, contentType?:any}): Promise<any> {
		return new Promise((resolve, reject)=>{
			if (options.key) {
				const body:any = { 'key': options.key, type: options.type };
				if(options.responseType) body.responseType = options.responseType;
				if(options.contentType) body.contentType = options.contentType;
				this._dataService.post('/auth/generatePreview', body, {showBusy: !options.hideLoader} ).subscribe((res: any) => {
					if(res.ok) {
						resolve(res.data);
					} else {
						if(options.responseType) resolve(res);
						else reject("ERROR: could not download file for preview.");
					}
				});
			} else {
				reject("ERROR: No item selected");
			}
		});
	}

	getBundleContent(url, obj, callback) {
		const body = {
			'ID': obj.itemID,
			'itemType': obj.itemType,
			'settings': JSON.stringify(obj.settings),
			'itemList': JSON.stringify(obj.itemList)
		};
		this._dataService.post(url, body)
			.subscribe(
				(data: { data: any, zipName: string, response: string, response_message: Array<any>, meta: any }) => {
					if (data.response === 'success') {
						callback(null, data.data, data.zipName, data.meta);
					}
				},
				(error: { data: any, zipName: string, response: string, response_message: string, meta: any }) => {
					callback(error["error"].response_message || 'error', null);
				});
	}

	onTreeSelectChange(event: Array<string>) {
		this.isAllSelected = event.length === this.fileCounter;
		this.selectedContents = event;
		this.checkedProductItems = [];
		this.checkedFolderItems = [];
		this.checkedFileItems = [];
		this.selectedIsbn = this.treedata[0].value.isbn || null;
		this.internalTcmId = this.treedata[0].value.internalTcmId || '';

		if ((this.selectedContents || []).length < 1) {
			this.noSelectedBtnStyle = "no-checkbox-active-class";
		}
		else {
			this.noSelectedBtnStyle = " ";
		}

	}

	setProduct(path): string {
		const prodIndex = path[0].split('product')[1];
		// this.treedata[prodIndex].checked = true;
		this.checkedProductItems.push(this.treedata[prodIndex].value.data);
		return prodIndex;
	}

	setLevel2FileOrFolder(path, prodIndex): string {
		const isFile = path[1].indexOf('file') > -1 ? true : false;
		const folderOrFileIndex = path[1].split((isFile ? 'file' : 'folder'))[1];
		let childFolders = [],
			childFiles = [];
		for (let innerNode of this.treedata[prodIndex].value.children) {
			if (innerNode.tcm_type === 'folder')
				childFolders.push(innerNode);
			else if (innerNode.tcm_type === 'file')
				childFiles.push(innerNode);
		}

		if (isFile) {
			this.checkedFileItems.push({
				...(childFiles[folderOrFileIndex].data),
				rootProduct: childFiles[folderOrFileIndex].rootProduct
			});
		} else
			this.checkedFolderItems.push({
				...(childFolders[folderOrFileIndex].data),
				rootProduct: childFolders[folderOrFileIndex].rootProduct
			});

		return folderOrFileIndex;
	}

	setLevel3File(path, prodIndex, L2Index) {
		// picking only file with prefixes
		const fileIndex = path[2].split('file')[1];
		if (fileIndex < 0)
			return null;

		let childFolders = [], childFiles = [];
		for (let innerNode of this.treedata[prodIndex].value.children) {
			if (innerNode.tcm_type === 'folder')
				childFolders.push(innerNode);
			else if (innerNode.tcm_type === 'file')
				childFiles.push(innerNode);
		}

		this.checkedFileItems.push({
			...(childFolders[L2Index].children[fileIndex].data),
			rootProduct: childFolders[L2Index].children[fileIndex].rootProduct
		});

		return fileIndex;
	}

	setLevel4File(path, prodIndex, L2Index, L3Index) {
		// picking only file with prefixes
		const fileIndex = path[3].split('file')[1];
		if (fileIndex < 0)
			return null;

		let childFoldersL2 = [], childFilesL2 = [];
		for (let innerNode of this.treedata[prodIndex].value.children) {
			if (innerNode.tcm_type === 'folder')
				childFoldersL2.push(innerNode);
			else if (innerNode.tcm_type === 'file')
				childFilesL2.push(innerNode);
		}

		let childFolders = [], childFiles = [];
		for (let innerNode of this.treedata[prodIndex].value.children) {
			for (let l3Node of innerNode.children) {
				if (l3Node.tcm_type === 'folder')
					childFolders.push(l3Node);
				else if (l3Node.tcm_type === 'file')
					childFiles.push(l3Node);
			}
		}
		// childFolders[L3Index]
		this.checkedFileItems.push({
			...(childFoldersL2[L2Index].children[L3Index].children[fileIndex].data),
			rootProduct: childFoldersL2[L2Index].children[L3Index].children[fileIndex].rootProduct
		});
		return fileIndex;
	}

	setLevel5File(path, prodIndex, L2Index, L3Index, L4Index) {
		// picking only file with prefixes
		const fileIndex = path[4].split('file')[1];
		if (fileIndex < 0)
			return null;
		let childFoldersL2 = [], childFilesL2 = [];
		for (let innerNode of this.treedata[prodIndex].value.children) {
			if (innerNode.tcm_type === 'folder')
				childFoldersL2.push(innerNode);
			else if (innerNode.tcm_type === 'file')
				childFilesL2.push(innerNode);
		}

		// childFolders[L3Index]
		this.checkedFileItems.push({
			...(childFoldersL2[L2Index].children[L3Index].children[L4Index].children[fileIndex].data),
			rootProduct: childFoldersL2[L2Index].children[L3Index].children[L4Index].children[fileIndex].rootProduct
		});

		return fileIndex;
	}

	// onFilterChange(event: Event) {
	//     // search functionality
	// }


	// this._dataService.postWithProgress('/auth/contentDownload', body, { isLoop: false, loopLength: 0, count: '0' })
	// (data: any) => {
	// if (data.type === HttpEventType.DownloadProgress)
	//   console.log('DOWNLOD' + JSON.stringify(data));

	// if (data.type === HttpEventType.UploadProgress)
	//   console.log('UPLOAD' + JSON.stringify(data));

	// if (data.type === HttpEventType.ResponseHeader)
	//   console.log('ResHEADER' + JSON.stringify(data));

	// if (data.type === HttpEventType.Response)
	//   console.log('RESPONSE' + JSON.parse(data));
	//  else if (data.response === 'progress') {
	//             this.progressBarValue = (data.data || {}).progress || 30;
	//           }

	startProgress(time = 250, breakPoint = 50) {
		this.progressControl = setInterval(() => {
			this.progressBarValue += 1;
			if (this.progressBarValue >= breakPoint) {
				clearInterval(this.progressControl);
				this.startProgress(time + 300, (breakPoint + 10));
			}
			if (this.progressBarValue >= 94) {
				clearInterval(this.progressControl);
			}
		}, time);
	}

	getProgressFromDB(guid) {
		const q = `SELECT download_progress FROM download_queue_cron WHERE download_progress LIKE '${guid}__%' and id > 0;`;
		this.progressControl = setInterval(() => {
			this._dataService.getProgressBarValueFromDB(`/auth/downloadProgressBar`, { queryString: q }).subscribe((resp: { error: string, result: number }) => {
				resp;
				this.progressBarValue = resp.result == -1 ? this.progressBarValue : resp.result;
			});
		}, 2000);
	}

	contentDownload(progressModal, thanksModal) {
		if ((this.selectedContents || []).length < 1) {
			//this._toastrService.typeCustomError('Please select at least one item and try again.');
			this._toastrService.typeCustomError('Please select at least one item and try again.');
			return;
		}

		this.isDownloadCancelled = false;
		this.disableCancelBtn = false;

		this.progressBarRef = this._modalService.open(progressModal, this.modalConf);
		(<any>window).gtag('event', 'Click', {
			'event_category': 'Button Clicked',
			'event_label': `Download Button for ${this.bundleName}`
		});

		this.progressBarValue = 0;
		if (this.isAllSelected) {
			this.downloadAllProductItems(thanksModal);
			return;
		}
		const guid = (uuid.v4());
		const body = {
			'checkedItems': {
				'selectedContents': this.selectedContents || [],
				'tcmId': this.responseItems[0].data.bundle_tcm_id,
				'itemName': this.bundleName.trim(),
				'S3ProductName': this.responseItems[0].S3ProductName.trim(),
				'isbn': this.selectedIsbn.trim().toLowerCase(),
				'internalTcmId': this.internalTcmId.trim().toLowerCase(),
				'zipName': (this.zipName).trim()
			},
			'isAllProduct': (!!this.zipName && this.isAllSelected), // true    // zipName handler
			'downloadDetails': {
				product_id: this.bundleID,
				guid
			},
			isAllSelected: this.isAllSelected
		};
		// console.log('Downloading selected contents...');
		this.downloadRequestSubscription = this._dataService.post('/auth/instantDownload', body, { showBusy: false })
			.subscribe(
				(rsp: { data: string, response: string, response_message?: string }) => {
					if (!!rsp.data && rsp.response == 'success') {
						if (this.isDownloadCancelled == true) {
							this.instantDownloadLink = '';
							clearInterval(this.progressControl);
							return;
						}

						this.instantDownloadLink = rsp.data;
						clearInterval(this.progressControl);
						this.progressBarValue = 100;
						this.disableCancelBtn = true;

						setTimeout(() => {
							this.closeProgressBarModal(thanksModal);
						}, 2000);

					} else {
						this._toastrService.typeCustomError('An error occurred during file download.  Please try your request again.');
						clearInterval(this.progressControl);

					}
				}
				, (error) => {
					this._toastrService.typeCustomError(((error || {}).error || {}).response_message || error.status_text);
					this.progressBarRef.close();
					clearInterval(this.progressControl);
				});
		this.getProgressFromDB(guid);
	}

	selectedForPreview:any = null;
	previewItemType:any= null;
	previewItemLoader:boolean = false;
	previewURL:any= null;
	previewData:any= null;
	async onFileSelect(e:any) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		if(this.gridViewEnabled) return;
		(function loop(el:any){
			el.forEach((_el:any)=>{
				if(_el && _el.tcm_type == "file") _el.selected = false;
				if(_el && _el.tcm_type != "file" && _el.children && _el.children.length > 0) loop(_el.children);
			});
		})(this.childTreeData);
		e.item.selected = true;
		let key = e.item.data.Key;
		this.previewItemType = /^.+\.([^.]+)$/.exec(key)[1];
		this.previewData = null;
		this.selectedForPreview = null;
		this.previewItemLoader = true;
		if(this.previewItemType == 'pdf') {
			this.getFileObject({key: key, type: 'application/pdf', hideLoader: this.previewItemLoader}).then((data)=>{
				let objectURL = URL.createObjectURL(data);
				this.previewURL = objectURL;
				setTimeout((i)=>{this.selectedForPreview=i; this.previewItemLoader = false;},0,e.item);
			});
		} else if(this.previewItemType == 'zip' || this.previewItemType == 'epub' || this.previewItemType == 'ppt' || this.previewItemType == 'pptx') {
			this.selectedForPreview = true;
			this.previewItemLoader = false;
		} else if(this.previewItemType == 'xls' || this.previewItemType == 'xlsx'){
			this.generatePreview({key: key, type: this.previewItemType, hideLoader: this.previewItemLoader}).then((data)=>{
				console.log(data);
				this.previewData = data[0].html;
				setTimeout((i)=>{this.selectedForPreview=true; this.previewItemLoader = false;},0,e.item);
			});
		} else if (this.previewItemType == 'doc' || this.previewItemType == 'docx') {
			this.generatePreview({key: key, type: this.previewItemType, hideLoader: this.previewItemLoader}).then((data)=>{
				this.previewData = data;
				setTimeout((i)=>{this.selectedForPreview=true; this.previewItemLoader = false;},0,e.item);
			});
		} else if (this.previewItemType == 'ppt' || this.previewItemType == 'pptx') {
			// this.generatePreview({key: key, type: this.previewItemType, hideLoader: this.previewItemLoader, responseType: 'blob', contentType: 'application/pdf'}).then((blob)=>{
			// 	let objectURL = URL.createObjectURL(blob);
			// 	this.previewURL = objectURL;
			// 	setTimeout((i)=>{this.selectedForPreview=true; this.previewItemLoader = false;},0,e.item);
			// });
		} else {
			let options = {
				hideLoader: this.previewItemLoader,
				shareable: false
			}
			this.getPublicUrl(key, options).then((url)=>{
				this.previewURL = url;
				setTimeout((i)=>{this.selectedForPreview=i; this.previewItemLoader = false;},0,e.item);
			}).catch((error)=>{
				console.log(error);
			});
		}
		
		if(this.pinnedItem) this.pinnedItem.pinned = false;
		e.item.pinned = true;
		this.pinnedItem = e.item;
	}

	pinnedItem:any = null;
	downloadAllProcessing:boolean = false;
	downloadSelectedProcessing:boolean = false;

	onFileActionButtonClicked(e:any, options:any = { progressModal: null, thanksModal: null, shareModal: null}) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();

		if(e.action == "download") {
			this.downloadContent(e, e.item,  options.progressModal, options.thanksModal);
		}

		if(e.action == "open") {
			this.openInNewTab(e.item.data.Key);
		}

		if(e.action == "share") {
			console.log('share this item');
			this.openShareModal(e.item, options.shareModal);
		}

		if(e.action == "pin") {
			if(this.pinnedItem) this.pinnedItem.pinned = false;
			e.item.pinned = true;
			this.pinnedItem = e.item;
		}
		
		if(e.action == "unpin") {
			this.pinnedItem.pinned = false;
			this.pinnedItem = null;
		}
	}

	openInNewTab(file) {
		window.open(environment.serverBaseURL + (environment.serverBasePort ? ':' + environment.serverBasePort : '') + '/view?id='+btoa(file), '_blank');
	}

	containerFolder: any = null;
	downloadContent(e: Event, item?:any,  progressModal?:any, thanksModal?:any) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		
		this.containerFolder = null;
		this.isAllSelected = item ? item.tcm_type == "root_folder" ? true : false : true;
		this.selectedIsbn = this.treedata[0].value.isbn || null;
		this.internalTcmId = this.treedata[0].value.internalTcmId || '';
		this.progressBarRef = this._modalService.open(progressModal, this.modalConf);
		let selectedItems = [];
		(function getSelected(_items){
			_items.forEach((_item)=>{
				if((_item.tcm_type == "folder" || _item.tcm_type == "root_folder") && _item.children.length > 0) {
					getSelected(_item.children);
				} else if(_item.tcm_type == "file"){
					selectedItems.push(_item.value);
				}
			});
		})((item ? [item] : this.treedata));
		
		this.selectedContents = selectedItems;
		if(!item) this.downloadAllProcessing = true;
		else this.downloadSelectedProcessing = true;
		if(item && item.tcm_type == 'file') {
			this.isDownloadCancelled = false;
			this.disableCancelBtn = false;
			this.startProgress((200+((item.data.Size/(1024*1024))*2)), 100);
			this.downloadRequestSubscription = this.getFileObject({key: item.data.Key, type: 'application/octet-stream', hideLoader: true, observable: true, productId: this.bundleID }).subscribe((data)=>{
				if(!this.isDownloadCancelled) {
					clearInterval(this.progressControl);
					this.progressBarValue = 100;
					setTimeout(() => {
						this.closeProgressBarModal(null);
						this.downloadAllProcessing = false;
						this.downloadSelectedProcessing = false;
						this.saveBlob(data, item.data.name);
					}, 400);
				}
			}, (error) => {
				clearInterval(this.progressControl);
			});
		} else {
			this.containerFolder = item ? item : null;
			this.downloadAllProductItems(null);
		}
	}
	saveBlob(blob:Blob, fileName:string) {
		let a:any = document.createElement("a");
		document.body.appendChild(a);
		a.style = "display: none";
	
		var url = window.URL.createObjectURL(blob);
		a.href = url;
		a.download = fileName;
		a.click();
		window.URL.revokeObjectURL(url);
	};
	downloadAllProductItems(thanksModal?:any) {
		this.downloadRequestSubscription = this._dataService.post('/auth/instantDownload', {
			'checkedItems': {
				'selectedContents': this.selectedContents || [],
				'tcmId': this.responseItems[0].data.bundle_tcm_id,
				'itemName': this.bundleName.replace(/:/g, '_').replace(/–/g, '-').trim(),
				'S3ProductName': this.responseItems[0].S3ProductName.trim(),
				'isbn': this.selectedIsbn.trim().toLowerCase(),
				'internalTcmId': this.internalTcmId.trim().toLowerCase(),
				'zipName': (this.zipName),
				'containerFolder': this.containerFolder && this.containerFolder.id ? this.containerFolder.id : null,
				'folderName': this.containerFolder && this.containerFolder.text ? this.containerFolder.text.replace(/:/g, '_').replace(/–/g, '-') : null
			},
			'isAllProduct': (!!this.zipName && this.isAllSelected), // true    // zipName handler
			'downloadDetails': {
				product_id: this.bundleID,
				guid: (uuid.v4())
			},
			isAllSelected: this.isAllSelected
		}, { showBusy: false }).subscribe(
			(rsp: any) => {
				if (!!rsp.data && rsp.response == 'success') {
					if (this.isDownloadCancelled == true) {
						this.instantDownloadLink = '';
						clearInterval(this.progressControl);
						return;
					}

					this.instantDownloadLink = rsp.data;
					clearInterval(this.progressControl);
					this.progressBarValue = 100;
					this.disableCancelBtn = true;

					setTimeout(() => {
						this.closeProgressBarModal(thanksModal);
						this.downloadAllProcessing = false;
						this.downloadSelectedProcessing = false;
					}, 1000);
					

				} else {
					this._toastrService.typeCustomError('An error occurred during file download.  Please try your request again.');
					clearInterval(this.progressControl);
				}
			}
			, (error) => {
				console.log('error ', error)
				this._toastrService.typeCustomError(((error || {}).error || {}).response_message || error.status_text);
				clearInterval(this.progressControl);
			});
		this.startProgress(50, 30);
	}

	_errorHandler(error: Response) {
		return Observable.throw(error || 'Internal server error');
	}


	/* To copy Text from Textbox */
	copyInputMessage(inputElement) {
		(<any>window).gtag('event', 'Click', {
			'event_category': 'Button Clicked',
			'event_label': `Copy Button for ${this.bundleName}`
		});

		inputElement.select();
		document.execCommand('copy');
		inputElement.setSelectionRange(0, 0);
		this._toastrService.typeCustomSuccess('Link copied to clipboard');
	}

	fireExternalLinkGAEvent(element) {
		(<any>window).gtag('event', 'Click', {
			'event_category': 'Button Clicked',
			'event_label': `${element} for ${this.bundleName}`
		});
	}

	cancelDownloading() {
		console.log('here')
		this.isDownloadCancelled = true;
		if(this.downloadRequestSubscription) this.downloadRequestSubscription.unsubscribe();
		clearInterval(this.progressControl);
		this.disableCancelBtn = true;
		this.downloadAllProcessing = false;
		this.downloadSelectedProcessing = false;
		this.closeProgressBarModal(null);
	}

	closeProgressBarModal(thanksModal) {
		this.progressBarRef.dismiss();
		this.progressBarValue = 0;
		if (thanksModal) {
			this.thanksRef = this._modalService.open(thanksModal, this.thanksModalConf);
			// setTimeout(() => {
				// this.thanksRef.dismiss();
			// }, 5000);
		}
	}

	open(content) {
		this._modalService.open(content, { size: 'sm', windowClass: 'thanks-modal' });
	}

	toggleItemPreviewView(e:Event) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();

		this.gridViewEnabled =! this.gridViewEnabled; 
	}

	onOnlineLibButtonHover(val) {
		this.onlineLibButtonHover = val;
	}

	searchText:string = null;
	onSearchContentInput() {
		this.currentDropdownSelection = this.treedata[0];
	}

	shareModalRef: any = null;
	sharableLink:string = '';
	sharableLinkCopied:boolean = false;
	openShareModal(item:any, shareModal:any) {
		this.sharableLinkCopied = false;
		this.sharableLink = environment.serverBaseURL + (environment.serverBasePort ? ':' + environment.serverBasePort : '') + '/share?id='+btoa(item.data.Key);
		this.shareModalRef = this._modalService.open(shareModal, {windowClass: 'share-modal'});
	}
	copyShareLink() {
		let _navigator:any = navigator;
		_navigator.clipboard.writeText(this.sharableLink);
		this.sharableLinkCopied = true;
	}
	selectShareLink(e:any) {
		e.target.select();
	}
	closeShareModal() {
		if(this.shareModalRef) {
			this.shareModalRef.dismiss();
			this.shareModalRef = null;
		}
	}

	
	onEdit() {
        $(".app-scrollable-content").animate({scrollTop: 0});
    }

    getContentScrolltop(cb) {
        let scrolltop = 0;
        $(".app-scrollable-content").scroll(()=>{
            scrolltop = $(".app-scrollable-content").scrollTop();
            cb(scrolltop);
        });
    }
}







// For Reference
/**HTTP Downloader*/
  // contentDownload(progressModal) {
  //   this.progressBarRef = this._modalService.open(progressModal);
  //   (<any>window).gtag('event', 'Click', {
  //     'event_category': 'Button Clicked',
  //     'event_label': `Download Button for ${this.bundleName}`
  //   });

  //   this.progressBarValue = 0;
  //   if (this.isAllSelected) {
  //     this.downloadAllProductItems();
  //     return;
  //   }

  //   const body = {
  //     'checkedItems': {
  //       'selectedContents': this.selectedContents || [],
  //       'tcmId': this.responseItems[0].data.bundle_tcm_id,
  //       'itemName': this.bundleName.trim(),
  //       'S3ProductName': this.responseItems[0].S3ProductName.trim(),
  //       'isbn': this.selectedIsbn.trim().toLowerCase(),
  //       'internalTcmId': this.internalTcmId.trim().toLowerCase(),
  //       'zipName': (this.zipName).trim()
  //     },
  //     'isAllProduct': (!!this.zipName && this.isAllSelected), // true    // zipName handler
  //     'downloadDetails': {
  //       product_id: this.bundleID
  //     },
  //     isAllSelected: this.isAllSelected
  //   };
  //   // console.log('Downloading selected contents...');
  //   this._dataService.postForDownloadingFileWithProgress('/auth/instantDownload', body, { observeType: 'events' })
  //     .subscribe(
  //       (data: { fileName: string, fileBlob: Blob, progress?: string, type?: number }) => {
  //         // 
  //         if ((data || { progress: null }).progress) {
  //           /**HTTP Download Progress */
  //           clearInterval(this.progressControl);
  //           this.progressBarValue = isNaN(parseInt(data.progress, 10)) ? this.progressBarValue : parseInt(data.progress, 10);
  //           console.log(this.progressBarValue);
  //           /********/
  //         } else if (!!(data || { fileBlob: null }).fileBlob) {
  //           /**HTTP Download Response */
  //           saveAs(data.fileBlob, data.fileName);
  //           clearInterval(this.progressControl);

  //           this.closeProgressBarModal();
  //           /********/
  //         }
  //       }
  //       , (error) => {
  //         this._toastrService.typeCustomError(error.error.response_message || error.status_text);
  //         this.progressBarRef.close();
  //       });
  //   this.startProgress();
  // }

  // downloadAllProductItems() {
  //   this._dataService.postForDownloadingFileWithProgress('/auth/instantDownload', {
  //     'checkedItems': {
  //       'selectedContents': this.selectedContents || [],
  //       'tcmId': this.responseItems[0].data.bundle_tcm_id,
  //       'itemName': this.bundleName.trim(),
  //       'S3ProductName': this.responseItems[0].S3ProductName.trim(),
  //       'isbn': this.selectedIsbn.trim().toLowerCase(),
  //       'internalTcmId': this.internalTcmId.trim().toLowerCase(),
  //       'zipName': (this.zipName || '').trim()
  //     },
  //     'isAllProduct': (!!this.zipName && this.isAllSelected), // true    // zipName handler
  //     'downloadDetails': {
  //       product_id: this.bundleID
  //     },
  //     isAllSelected: this.isAllSelected
  //     // }, { observeType: 'response' }).subscribe(
  //   }, { observeType: 'events' }).subscribe(
  //     (data: { fileName: string, fileBlob: Blob, progress?: string, type?: number }) => {
  //       // 
  //       if ((data || { progress: null }).progress) {
  //         /**HTTP Download Progress*/
  //         clearInterval(this.progressControl);
  //         this.progressBarValue = isNaN(parseInt(data.progress, 10)) ? this.progressBarValue : parseInt(data.progress, 10);
  //         console.log(this.progressBarValue);
  //         /***********/
  //       } else if (!!(data || { fileBlob: null }).fileBlob) {
  //         /**HTTP Download Response*/
  //         saveAs(data.fileBlob, data.fileName);
  //         clearInterval(this.progressControl);
  //         this.progressBarValue = 100;
  //         this.disableCancelBtn = true;

  //         this.closeProgressBarModal();
  //         /********/
  //       }
  //     }

  //     , (error) => {
  //       this._toastrService.typeCustomError(((error || {}).error || {}).response_message || error.status_text);
  //     });
  //   this.startProgress(50, 70);
  // }
/*****HTTP Downloader******/



// WEBPACK FOOTER //
// ./public/app/modules/my-content/download/download.component.ts